import React, { useEffect } from "react";
import { navigate, RouteComponentProps, useParams } from "@reach/router";
import Logo from "../../resources/RezolveAI_Logo.svg";
import Spinner from "../../components/Spinner";
import useIsMobile from "../../hooks/useIsMobile";
import { useAriaHideMainContent } from "../../hooks/useSharedContext";
import * as styled from "./styled";

export const HelloDashboardRedirect = (_props: RouteComponentProps) => {
  const { region, urlCode } = useParams();
  const isMobile = useIsMobile();
  const { hideMainContent } = useAriaHideMainContent();

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const searchParams = new URLSearchParams(window.location.search);
      const destinationId = searchParams.get("destinationId");

      let redirectUrl = `${process.env.REACT_APP_HELLO_SCREENS_DASHBOARD_URL}/${region}/sso/${urlCode}`;
      if (destinationId) {
        redirectUrl += `?destinationId=${destinationId}`;
      }

      navigate(redirectUrl);
    }, 300);

    return () => clearTimeout(timeoutId);
  }, [region, urlCode]);

  useEffect(() => {
    document.title = "Hello Screens - Redirecting";
  }, []);

  const pageContent = (
    <>
      <styled.LogoWrapper>
        <styled.LogoImage src={Logo} title="Rezolve AI Logo" alt="Rezolve AI Logo" />
      </styled.LogoWrapper>
      <Spinner />
      <styled.LoadingText>Redirecting...</styled.LoadingText>
    </>
  );

  if (isMobile) {
    return (
      <styled.BackgroundPanelMobile aria-hidden={hideMainContent}>
        <styled.RedirectMobilePanel>
          <styled.CenterAlignmentWrapper>{pageContent}</styled.CenterAlignmentWrapper>
        </styled.RedirectMobilePanel>
      </styled.BackgroundPanelMobile>
    );
  }

  return (
    <styled.BackgroundPanel aria-hidden={hideMainContent}>
      <styled.CenterAlignmentWrapper>
        <styled.RedirectWrapper>{pageContent}</styled.RedirectWrapper>
      </styled.CenterAlignmentWrapper>
    </styled.BackgroundPanel>
  );
};
